import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';
import EagleLogo from '../assets/eagle.svg';
import AccoladeLogo from '../assets/accolade.svg';

interface SidebarProps { isOpen?: boolean; onClose?: () => void; }

const Sidebar: React.FC<SidebarProps> = ({ isOpen = false, onClose }) => {
  const logout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <button className="sidebar-close" onClick={onClose} aria-label="Close sidebar">×</button>
      <div className="brand">
        <div className="brand-logo-wrap">
          <img src={EagleLogo} className="brand-logo" alt="Eagle" />
        </div>
        <div className="brand-text">Admin Portal</div>
      </div>
      <nav>
        <ul>
          <li><NavLink to="/app/dashboard">Dashboard</NavLink></li>
          <li><NavLink to="/app/command-repo">Command Repository</NavLink></li>
          <li><NavLink to="/app/firmware-repo">Firmware Repository</NavLink></li>
          <li><NavLink to="/app/audit">Device History</NavLink></li>
          <li><NavLink to="/app/settings">Settings</NavLink></li>
        </ul>
      </nav>
      <div className="sidebar-footer">
        <img src={AccoladeLogo} className="accolade-logo" alt="Accolade" />
        <button onClick={logout}>Logout</button>
      </div>
    </aside>
  );
};

export default Sidebar;
